import {
  Button,
  Card,
  Group,
  LoadingOverlay,
  Stack,
  Title,
} from '@mantine/core';
import { useFetch } from '@mantine/hooks';
import { Info, Lock } from 'lucide-react';
import { useAuthUser } from '../../../providers/AuthProvider';
import { getAppColor } from '../../../utils/getAppColor';
import { getShopProductUrl } from '../../../utils/shopUrl';

interface Product {
  id: number;
  product_id: number;
  name: string;
  slug: string;
}

export function InactiveSubscriptions() {
  const user = useAuthUser();
  const userId = user?.id;

  const { data: allProductsResponse, loading: allProductsLoading } = useFetch<{
    data: { products: Product[] };
  }>(`${import.meta.env.VITE_API_URL}/services/products`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
  });

  const { data: userProductsResponse, loading: userProductsLoading } =
    useFetch<{
      data: Product[];
    }>(
      userId
        ? `${import.meta.env.VITE_API_URL}/services/admin/users/${userId}/products`
        : '',
      {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

  const allProducts = allProductsResponse?.data?.products ?? [];
  const userProducts = userProductsResponse?.data ?? [];

  const userProductIds = userProducts.map(p => p.product_id);

  const inactiveSubscriptions = allProducts
    .filter(product => product.id >= 75 && product.id <= 81)
    .filter(product => !userProductIds.includes(product.id));

  const subscriptionOrder = [
    'Augmented Wellbeing',
    'Augmented Psychology',
    'Augmented Situations',
    'Augmented Mentalization',
    'Augmented Exposure',
    'Augmented Performance',
    'Augmented Corporate',
  ];

  const orderedInactiveSubscriptions = [...inactiveSubscriptions].sort(
    (a, b) =>
      subscriptionOrder.indexOf(a.name) - subscriptionOrder.indexOf(b.name)
  );

  return (
    <Card shadow='sm' withBorder p='sm' radius='sm'>
      <Title order={4} mb='sm'>
        Abbonamenti inattivi
      </Title>
      <LoadingOverlay visible={allProductsLoading || userProductsLoading} />

      <Stack gap='sm'>
        {orderedInactiveSubscriptions.map(sub => (
          <Card
            key={sub.id}
            p='md'
            radius='sm'
            style={{ background: getAppColor(sub.name) }}
          >
            <Group justify='space-between'>
              <Group>
                <Lock size={16} color='white' />
                <Title c='white' order={5}>
                  {sub.name}
                </Title>
              </Group>
              <Button
                leftSection={<Info size={16} />}
                color='white'
                variant='outline'
                onClick={() => {
                  window.open(
                    getShopProductUrl(sub.slug),
                    '_blank',
                    'noopener,noreferrer'
                  );
                }}
                radius='sm'
              >
                Sblocca
              </Button>
            </Group>
          </Card>
        ))}

        {orderedInactiveSubscriptions.length === 0 && (
          <Title order={6} c='gray'>
            Nessun abbonamento inattivo
          </Title>
        )}
      </Stack>
    </Card>
  );
}
